<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb
            :title="page.title"
            :breadcrumbs="breadcrumbs"
         ></BaseBreadcrumb>

         <v-alert
            dense
            text
            :type="canRenew ? 'success' : 'info'"
            class="mb-4"
         >
            <strong>CPD Points:</strong> {{ totalcpd || 0 }}
            <span v-if="theyear"> for {{ theyear }}</span>.
            <span v-if="canRenew"> You may proceed with your membership renewal payment below.</span>
            <span v-else> Please review your CPD record before proceeding with renewal.</span>
         </v-alert>

         <v-row>
            <v-col cols="12">
               <table-payment-s-f ref="tblpay"></table-payment-s-f>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import TablePaymentSF from './Tables/TablePaymentSF.vue'

export default {
   name: "MOMMemberRenewal",
   components: {
      DashboardLayout,
      BaseBreadcrumb,
      TablePaymentSF,
   },
   props: {
      theyear: { type: [String, Number], default: '' },
      memberinfo: { type: Object, default: null },
      totalcpd: { type: [String, Number], default: 0 },
   },
   data() {
      return {
         page: { title: "Membership Renewal" },
         breadcrumbs: [
            { text: "Dashboard", disabled: false, to: "/dashboard" },
            { text: "Membership Payments", disabled: false, to: "/member/payments" },
            { text: "Renewal", disabled: true },
         ],
      }
   },
   computed: {
      canRenew() {
         return Number(this.totalcpd || 0) >= 12
      },
   },
   mounted() {
      const user = this.$page.user
      if (this.$refs.tblpay && user) {
         this.$refs.tblpay.setuserid(user.id)
      }
   },
}
</script>
